import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, Check } from "lucide-react";

export default function AdminNotifications() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/notifications");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="p-6 lg:p-10" data-testid="admin-notifications-page">
      <header className="mb-8 flex justify-between items-end flex-wrap gap-4">
        <div>
          <div className="text-[10px] font-mono tracking-[0.3em] uppercase text-zinc-500">Flux</div>
          <h1 className="font-display font-black uppercase text-4xl lg:text-5xl tracking-tighter">Notifications</h1>
        </div>
        <button onClick={markAll} data-testid="mark-all-read-btn" className="inline-flex items-center gap-2 border border-zinc-900 px-4 py-2.5 font-bold hover:bg-zinc-900 hover:text-white">
          <Check size={16} /> Tout marquer lu
        </button>
      </header>

      <div className="border border-zinc-900 max-w-3xl divide-y divide-zinc-200" data-testid="notifications-list">
        {items.length === 0 ? (
          <div className="p-8 text-sm text-zinc-500 flex flex-col items-center gap-2">
            <BellRing size={24} />
            Aucune notification.
          </div>
        ) : items.map((n) => (
          <div key={n.id} className={`p-4 flex items-start gap-3 ${n.read ? "opacity-70" : ""}`}>
            <div className={`mt-1 w-2 h-2 ${n.read ? "bg-zinc-300" : "bg-[#FFC60A]"}`} />
            <div className="flex-1">
              <div className="flex justify-between">
                <div className="font-semibold">{n.title}</div>
                <div className="text-[10px] font-mono text-zinc-500">{n.created_at.slice(11, 16)}</div>
              </div>
              <div className="text-sm text-zinc-600 mt-0.5">{n.body}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
